export default "__VITE_ASSET__Cjyq71oy__"